export default __webpack_public_path__ + "static/10-mouth-watering-destinations-for-unashamed-foodies-switzerland-729c61c7ae43544b649a8ea9d31cd1a0.jpg";